<template lang="pug">
.settings-head__menu
  .settings-head__menu-desktop
    .settings-head__menu-item(
      v-for="item in menu",
      :key="item.icon",
      :class="{ active: isCurrentRoute(item.route) }"
    )
      router-link(:to="{ name: item.route }")
        svg-icon(:iconId="item.icon", useClass="settings-head__menu-item-icon")
        span {{ item.title }}
  .settings-head__menu-mobile
    b-dropdown#settingsMobileMenu
      template#button-content(v-slot:button-content)
        svg-icon(
          :iconId="currentItem.icon",
          useClass="settings-head__menu-item-icon"
        )
        span {{ currentItem.title }}
      b-dropdown-item(
        v-for="item in menu",
        :key="item.icon",
        :class="{ active: isCurrentRoute(item.route) }"
      ) 
        router-link(:to="{ name: item.route }")
          svg-icon(
            :iconId="item.icon",
            useClass="settings-head__menu-item-icon"
          )
          span {{ item.title }}
</template>

<script>
import { mapGetters } from "vuex";
import { BDropdown, BDropdownItem } from "bootstrap-vue";

export default {
  name: "settings-page-head",

  components: {
    BDropdown,
    BDropdownItem,
  },

  computed: {
    ...mapGetters(["authUser"]),

    currentRoute() {
      return this.$route.name;
    },

    hasBasicInfo() {
      return this.authUser.username && this.authUser.name;
    },
    gmhReady() {
      return this.authUser.meta.gmh_ready;
    },

    menu() {
      const menu = [
        {
          icon: "settings-my-profile",
          route: "settings-profile-page",
          title: "My Profile",
        },
        {
          icon: "settings-account-management",
          route: "settings-account-management-page",
          title: "Account Management",
        },
      ];

      if (this.authUser.game_master) {
        menu.push({
          icon: "settings-listing",
          route: "settings-listing-page",
          title: "Listing",
        });
        menu.push({
          icon: "settings-payouts",
          route: "settings-payouts-page",
          title: "Payouts",
        });
      }

      menu.push({
        icon: "settings-bookings",
        route: "settings-bookings-page",
        title: "Bookings",
      });
      menu.push({
        icon: "settings-reviews",
        route: "settings-reviews-page",
        title: "Reviews",
      });
      menu.push({
        icon: "settings-messages",
        route: "settings-messages-page",
        title: "Messages",
      });

      return menu;
    },

    currentItem() {
      return this.menu.find((item) => item.route == this.currentRoute);
    },
  },

  methods: {
    isCurrentRoute(name) {
      return this.currentRoute === name;
    },
  },
};
</script>
